import type { Frame } from '../store/types';

/** A design frame uses its own themeId, else falls back to the canvas active
 *  theme. Applied PER design frame (not via a canvas-wide wrapper) so canvas-
 *  native tool frames (chat/code/fx/note/styleguide), which use the chrome's
 *  --color-* vars, never inherit a theme's colliding color tokens.
 *  byId reserved for future cross-frame resolution. */
export function resolveThemeId(
  frame: Frame,
  _byId: Map<string, Frame>,
  activeThemeId?: string,
): string | undefined {
  return frame.themeId ?? activeThemeId;
}

export function applyTheme(
  root: HTMLElement,
  frame: Frame,
  byId: Map<string, Frame>,
  activeThemeId?: string,
): void {
  const id = resolveThemeId(frame, byId, activeThemeId);
  if (id) root.setAttribute('data-theme', id);
  else root.removeAttribute('data-theme');
}
